export const myCommunity = {
  // Page titles and navigation
  'backoffice.myCommunity.genealogyTreeTitle': 'Albero Genealogico',
  'backoffice.myCommunity.organizationalChart': 'Organigramma',
  'backoffice.myCommunity.treeViewTitle': 'Vista ad Albero',
  'backoffice.myCommunity.membersTitle': 'Membri della Comunità',
  'backoffice.myCommunity.genealogyTreeSubtitle': 'Esplora la tua gerarchia completa di referral',
  'backoffice.myCommunity.treeViewSubtitle': 'Vista in formato tabella della tua community',
  'backoffice.myCommunity.membersSubtitle': 'Lista di tutti i tuoi referral diretti e indiretti',

  // Common labels
  'backoffice.myCommunity.username': 'Nome Utente',
  'backoffice.myCommunity.status': 'Stato',
  'backoffice.myCommunity.rank': 'Rango',
  'backoffice.myCommunity.level': 'Livello',
  'backoffice.myCommunity.joinDate': 'Data di Registrazione',
  'backoffice.myCommunity.country': 'Paese',
  'backoffice.myCommunity.active': 'Attivo',
  'backoffice.myCommunity.inactive': 'Inattivo',
  'backoffice.myCommunity.loading': 'Caricamento...',
  'backoffice.myCommunity.loadMore': 'Carica Altri',
  'backoffice.myCommunity.expand': 'Espandi',
  'backoffice.myCommunity.collapse': 'Comprimi',
  'backoffice.myCommunity.resetView': 'Ripristina Vista',
  'backoffice.myCommunity.memberSince': 'Membro dal',
  'backoffice.myCommunity.comingSoon': 'In Arrivo...',

  // Tree specific
  'backoffice.myCommunity.directReferrals': 'Referral Diretti',
  'backoffice.myCommunity.treeLevel': 'Livello Albero',
  'backoffice.myCommunity.zoomIn': 'Ingrandisci',
  'backoffice.myCommunity.zoomOut': 'Riduci',
  
  // Members specific
  'backoffice.myCommunity.totalUsers': 'Totale Utenti',
  'backoffice.myCommunity.activeUsers': 'Utenti Attivi',
  'backoffice.myCommunity.inactiveUsers': 'Utenti Inattivi',
  'backoffice.myCommunity.levelStats': 'Statistiche Livello {level}',
  'backoffice.myCommunity.yourProfile': 'Il Tuo Profilo',
  'backoffice.myCommunity.communityMembers': 'Membri della Comunità',
  
  // Filters
  'backoffice.myCommunity.filterByLevel': 'Filtra per Livello',
  'backoffice.myCommunity.filterByStatus': 'Filtra per Stato',
  'backoffice.myCommunity.allLevels': 'Tutti i Livelli',
  'backoffice.myCommunity.allStatuses': 'Tutti gli Stati',
  
  // Error messages
  'backoffice.myCommunity.noDataFound': 'Nessun dato della comunità trovato',
  'backoffice.myCommunity.errorLoading': 'Errore nel caricamento dei dati della comunità',
  'backoffice.myCommunity.tryAgain': 'Riprova',

  // Table column headers - updated keys
  'backoffice.myCommunity.tableColumns.username': 'Nome Utente',
  'backoffice.myCommunity.tableColumns.name': 'Nome',
  'backoffice.myCommunity.tableColumns.status': 'Stato',
  'backoffice.myCommunity.tableColumns.rank': 'Rango',
  'backoffice.myCommunity.tableColumns.level': 'Livello',
  'backoffice.myCommunity.tableColumns.joinDate': 'Data di Registrazione',
  'backoffice.myCommunity.tableColumns.country': 'Paese',
};
